const months = {
  "0": "January",
  "1": "February",
  "10": "November",
  "11": "December",
  "2": "March",
  "3": "April",
  "4": "May",
  "5": "June",
  "6": "July",
  "7": "August",
  "8": "September",
  "9": "October"
}

interface DateFormatted {
  day: number
  fullDate: string
  month: string
  year: number
}

/**
 * @name formatDate
 * @description Formats a date string into an object with day, month, and year properties.
 * @param {string} dateString - The date string to format.
 * @returns {DateFormatted} An object containing the day, month, and year.
 *
 */
const formatDate = (dateString: string): DateFormatted => {
  const date = new Date(dateString)

  const day = date.getUTCDate()
  const month = months[date.getUTCMonth().toString() as keyof typeof months]
  const year = date.getUTCFullYear()

  const fullDate = `${day} ${month} ${year}`

  return {
    day,
    fullDate,
    month,
    year
  }
}

export default formatDate
